<template>
  <div class="tasks text-dark" :class="{'tasks--with-kids': isWithKids}">
    <div class="tasks-header">
      <h4>Personalets kalender</h4>
      <button :class="{'submit-button create-btn': !isWithKids}"
              @click="setCreateNewTask">
        Opret opgave for personale
      </button>
      <CreateTask
        v-if="isTaskModal"
        :editTask="theEditTask"
        :activeFilter="theActiveFilter"
        @create="createTask"
        @close="closeUpdateTask">
      </CreateTask>
    </div>
    <table class="d-table">
      <thead>
      <tr>
        <th class="task__task">Opgave</th>
        <th class="task__hours">Timer</th>
        <th class="task__calendars">Personale</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="task in sortedTasksWithProps" :key="task.id">
        <td class="task__task">
          <div class="task__name">
            <div @click="setEditTask(task)"
                 :class="[{'td-subject--hidden': !task.can_schedule}, {'td-subject': task.can_schedule}]"
                 :style="{'background-color': task.color}">{{ task.name }}
            </div>
          </div>
        </td>
        <td class="task__hours">{{ task.hours }}</td>
        <td class="task__calendars" @click="setActiveDSelect(task)"
            :class="{'d-select-lookalike': !task.v_is_active_d_select && task.v_staff_names.length < 1}"
            aria-placeholder-label="Søg og vælg">
          <DSelectCalendarIds v-if="task.v_is_active_d_select"
                              :show="activeDSelectShow"
                              v-on-clickaway="closeDSelect"
                              itemType="USER"
                              :preSelectedItems="task.user_calendar_ids"
                              :itemsThatCantBeDeleted="usersWithEvents(task)"
                              :showTags="false"
                              :content=" getUserNames(usersWithEvents(task)) + ' har skemalagte aktiviteter og kan ikke slettes'"
                              v-tippy="{
                                onShow: () => usersWithEvents(task).length > 0,
                                arrow: true,
                                placement : 'bottom'
                              }"
                              @update="setSelectedUsers($event, task)">
          </DSelectCalendarIds>
          <div class="task__users"
               v-if="!task.v_is_active_d_select && task.v_staff_names.length > 0">
            <p v-for="user in task.v_staff_names">{{ user }}</p>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="tasks.length < 1" class="explainer-div">Ikke oprettet nogen opgaver uden børn</div>
  </div>
</template>

<script>
import CreateTask from '../SubjectsDistribution/SubjectsDistributionTasksCreate'
import DSelectCalendarIds from '../DSelect/DSelectCalsIds'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  mixins: [clickaway],
  components: {DSelectCalendarIds, CreateTask},
  props: {
    isWithKids: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      theEditTask: null,
      isTaskModal: false,
      activeDSelectShow: false,
      activeDSelect: null
    }
  },
  computed: {
    theActiveFilter () {
      return this.isWithKids ? 'with_kids' : 'without_kids'
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    tasks () {
      return this.$store.state.subjects.tasks
    },
    filteredTasks () {
      if (!this.isWithKids) {
        return this.tasks.filter(task => task.subject_type === 'without_kids')
      } else {
        // Filter tasks based on specific criteria.
        const isTaskInOtherCalendar = task => {
          if (task.belongs_to_calendars.length !== 1) {
            return false
          }
          const calendarId = task.belongs_to_calendars[0]
          const cal = this.allCalendarsInHash[calendarId]
          return cal && cal.type === 'other'
        }

        return this.tasks.filter(task => {
          return task.subject_type === 'with_kids' && (task.in_user_calendar || isTaskInOtherCalendar(task))
        })
      }
    },
    sortedTasks () {
      return this.filteredTasks.sort((a, b) => a.name.localeCompare(b.name))
    },
    sortedTasksWithProps () {
      return this.sortedTasks.map(task => {
        const userNames = this.getUsers(task.user_calendar_ids)
        return {
          ...task,
          v_is_active_d_select: this.activeDSelect === task.id,
          v_staff_names: userNames
        }
      })
    }
  },
  methods: {
    getUsers (userCalIds) {
      return userCalIds.filter(calId => this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId].name)
    },
    setCreateNewTask () {
      this.theEditTask = null
      this.isTaskModal = true
    },
    closeUpdateTask () {
      this.isTaskModal = false
      this.theEditTask = null
    },
    createTask (task, {keepOpen = false} = {}) {
      this.isTaskModal = false
      task['schoolId'] = this.schoolId
      this.$store.dispatch('createTask', task)
      if (keepOpen) {
        setTimeout(_ => {
          this.isTaskModal = true
        }, 0)
      }
    },
    setEditTask (task) {
      this.isTaskModal = false
      this.theEditTask = task
      setTimeout(_ => {
        this.isTaskModal = true
      }, 0)
    },
    setActiveDSelect (task) {
      if (task.user_calendar_ids.length < 1) {
        this.activeDSelectShow = true
      } else {
        this.activeDSelectShow = false
      }
      this.activeDSelect = task.id
    },
    closeDSelect () {
      if (!this.activeDSelect) {
        return
      }
      this.activeDSelect = null
    },
    usersWithEvents (task) {
      let usersWithEvents = []
      task.subjects.forEach(subject => {
        if (subject.has_events) {
          if (subject.user_calendars.length > 0) {
            // Is in other calendar
            usersWithEvents = subject.user_calendars
          } else {
            // Is in own calendar
            usersWithEvents.push(subject.calendar_id)
          }
        }
      })
      return usersWithEvents
    },
    getUserNames (calIds) {
      return calIds.map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId].name : '')
    },
    setSelectedUsers (users, task) {
      if (!task) {
        this.fastFormUsers = users
        return
      }
      let belongsToCalendars = []
      let userCalendars = []
      let isInOtherCalendar = task.belongs_to_calendars[0] && this.allCalendarsInHash[task.belongs_to_calendars[0]] && this.allCalendarsInHash[task.belongs_to_calendars[0]].type === 'other'
      if (isInOtherCalendar) {
        belongsToCalendars = [task.belongs_to_calendars[0]]
        userCalendars = users.map(user => user.id)
      } else {
        belongsToCalendars = users.map(user => user.id)
      }
      let updatedTask = {
        schoolId: task.school_id,
        schoolYearId: task.school_year_id,
        id: task.id,
        name: task.name,
        color: task.color,
        hours: task.hours,
        defaultDuration: task.default_duration,
        belongsToCalendars: belongsToCalendars,
        userCalendars: userCalendars
      }
      this.updateTask(updatedTask)
    },
    updateTask (updatesForTask) {
      this.$store.dispatch('updateTask', updatesForTask)
      this.closeUpdateTask()
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.tasks-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 1rem;
}

.tasks--with-kids .tasks-header {
  padding: 1rem;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  margin-bottom: 0;
}
.tasks--with-kids .d-table {
  border-radius: 0 0 4px;
  border-width: 0 1px 1px 1px;
}

.create-btn {
  width: 200px;
  height: 38px;
  margin-left: 10px;
  color: white;
  box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
  background-color: var(--blue);
  border: 1px solid #4e80b7 !important;
  transition: background-color 0.3s, transform 0.3s;
  transform: scale(1);
}

.create-btn:hover {
  background-color: #66a1e4;
}

.create-btn:active {
  transform: scale(0.98)
}

.d-table {
  width: 100%;
  border-spacing: initial;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  position: relative;
}

.d-table thead tr th:first-child {
  border-radius: 4px 0 0 0;
  max-width: 200px;
  padding-left: 16px;
}

.d-table thead tr th:last-child {
  border-radius: 0 4px 0 0;
  padding-right: 16px;
}

.d-table tr th {
  padding: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.d-table thead {
  background: #f6f9fc;
  text-transform: uppercase;
  padding: 8px;
  font-weight: normal;
  border-collapse: collapse;
  text-align: left;
  border: 1px solid #e2e8f0;
  color: #8898aa;
}

.d-table tbody tr {
  background: #ffffff;
}

.d-table tr td {
  border-bottom: 1px solid rgba(226, 232, 240, 0.4);
  padding: 8px;
}

.d-table tbody tr td:first-child {
  font-weight: bold;
  padding-left: 4px;
}

.d-table tbody tr td:last-child {
  padding-right: 16px;
}

.d-table__number {
  text-align: right;
}

.explainer-div {
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  font-style: italic;
}

.task__name {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}

.task__name .td-subject--hidden {
  background: transparent !important;
}


.td-subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
  text-align: left;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
  width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.td-subject--hidden {
  width: 220px;
  border: 1px solid transparent;
  padding: 4px 6px;
  border-radius: 4px;
  height: 30px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.td-subject--hidden:hover {
  border-color: var(--border-color);
}

.td-subject--hidden:hover:before {
  content: "\e90e";
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  top: 8px;
  right: 4px;
  opacity: 0.7;
}


.task__users {
  min-height: 22px;
  width: 100%;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: border 0.1s;
}

.task__users:hover {
  border: 1px solid #acb6be;
}

.task__users > p {
  display: inline-block;
}

.task__users > p:after {
  content: ',';
  margin-right: 5px;
}

.task__users > p:last-child:after {
  content: '';
}


.d-select-lookalike {
  height: 42px;
  position: relative;
}

.d-select-lookalike:after {
  content: attr(aria-placeholder-label);
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  transition: width 0.25s;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 9px;
  background: #ffffff;
  cursor: text;
  border: 1px solid #acb6be;
}

.task__task {
  width: 250px;
}

.task__hours {
  width: 80px;
  text-align: right;
  padding-right: 40px !important;
}


</style>



// WEBPACK FOOTER //
// AnnualNormWithoutKids.vue?6ea4f470